import * as Yup from 'yup';

export const dataSchema = Yup.object().shape({
  blacklistType: Yup.string()
    .required('Tipo de blacklist obrigatório!')
    .typeError('Tipo de blacklist obrigatório!'),
  reason: Yup.string()
    .required('Motivo obrigatório!')
    .typeError('Motivo obrigatório!'),
  description: Yup.string()
    .min(30, 'Descrição deve ter pelo menos 30 caracteres')
    .required('Descrição obrigatória')
    .typeError('Descrição obrigatória'),

  personId: Yup.number().nullable().test(
    'at-least-one',
    'Campo obrigatorio!',
    function (_, ctx) {
      const { personId, vehicleId, wagonId } = ctx.parent;
      return !!(personId || vehicleId || wagonId);
    }
  ),

  vehicleId: Yup.number().nullable(),
  wagonId: Yup.number().nullable(),
});

export const dataSchemaUpdate = Yup.object().shape({
  reason: Yup.string()
    .required('Motivo obrigatório!')
    .typeError('Motivo obrigatório!'),
  description: Yup.string()
    .min(30, 'Descrição deve ter pelo menos 30 caracteres')
    .required('Descrição obrigatória')
    .typeError('Descrição obrigatória'),
});
